import { createClient } from '@/lib/supabase/client';

const EDGE_FUNCTION_URL = `${process.env.NEXT_PUBLIC_SUPABASE_URL}/functions/v1/send-email`;

async function invokeEmailFunction(payload: object): Promise<void> {
  const supabase = createClient();
  const { data: { session } } = await supabase.auth.getSession();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`;
  }

  try {
    const res = await fetch(EDGE_FUNCTION_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      console.error('[Email] Failed to send:', err);
    }
  } catch (err) {
    console.error('[Email] Network error:', err);
  }
}

/** Send registration confirmation email */
export async function sendRegistrationEmail(params: {
  to: string;
  fullName: string;
  accountType?: string;
}): Promise<void> {
  await invokeEmailFunction({
    type: 'registration',
    to: params.to,
    data: {
      fullName: params.fullName,
      accountType: params.accountType || 'student',
    },
  });
}

/** Send exam results notification email */
export async function sendResultsEmail(params: {
  to: string;
  fullName: string;
  olympiadName: string;
  score?: number | string;
  totalMarks?: number | string;
  percentile?: string;
  globalRank?: string;
  grade?: string;
  schoolName?: string;
  examDate?: string;
}): Promise<void> {
  await invokeEmailFunction({
    type: 'results',
    to: params.to,
    data: {
      fullName: params.fullName,
      olympiadName: params.olympiadName,
      score: params.score,
      totalMarks: params.totalMarks,
      percentile: params.percentile,
      globalRank: params.globalRank,
      grade: params.grade,
      schoolName: params.schoolName,
      examDate: params.examDate,
    },
  });
}

/** Send certificate delivery email */
export async function sendCertificateEmail(params: {
  to: string;
  fullName: string;
  olympiadName: string;
  score?: number | string;
  totalMarks?: number | string;
  percentile?: string;
  globalRank?: string;
  certificateId?: string;
  issueDate?: string;
  meritLevel?: string;
}): Promise<void> {
  await invokeEmailFunction({
    type: 'certificate',
    to: params.to,
    data: {
      fullName: params.fullName,
      olympiadName: params.olympiadName,
      score: params.score,
      totalMarks: params.totalMarks,
      percentile: params.percentile,
      globalRank: params.globalRank,
      certificateId: params.certificateId,
      issueDate: params.issueDate,
      meritLevel: params.meritLevel,
    },
  });
}
